import React from "react";
import CrackedCodeSlider from "../Frontend/Sliders/CrackedCodeSlider";
import ButtonComp from "./ButtonComp";
import NewCustomSlider from "./NewCustomSlider";

const TestimonialSection = ({
  title,
  subtitle,
  btnText,
  btnLink = "/auth/register",
  onBtnClick,
  showBtn = true,
  sliderList
}) => {
  const isOnlyTitle = !subtitle && !showBtn;
  return (
    <div className="sss-section testimonial-section">
      {/* Header: Title left, Subtitle + Button right */}
      <div className="custom-container">
        <div
          className={`testimonial-section__header ${
            isOnlyTitle ? "only-title" : ""
          }`}
        >
          <h2
            className="testimonial-section__title FS40FW600"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {!isOnlyTitle && (
            <div className="testimonial-section__right">
              {subtitle && (
                <p className="testimonial-section__subtitle quote-para FS16FW500">
                  {subtitle}
                </p>
              )}

              {showBtn &&
                btnText &&
                (onBtnClick ? (
                  <button className="primary-btn" onClick={onBtnClick}>
                    {btnText}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="CTA"
                    />
                  </button>
                ) : (
                  <ButtonComp btnText={btnText} link={btnLink} />
                ))}
            </div>
          )}
        </div>
      </div>

      {/* Slick Carousel Cards */}
      {/* <CrackedCodeSlider /> */}
      <NewCustomSlider data={sliderList} />
    </div>
  );
};

export default TestimonialSection;
